module.exports = __webpack_public_path__ + "static/index/img/baikal-802.ca1b8726.jpg";